import { openModal } from '@core/components/ModalStack';
import { TicketOrgModalProps } from './TicketOrgModal';

export async function openTicketOrg(props: TicketOrgModalProps) {
  const { TicketOrgModal } = await import('./TicketOrgModal');

  openModal(TicketOrgModal, props);
}
